import {BookingMode, Vehicle, VehicleSlot, VehicleType} from '@/lib/kepler/interfaces'
import theme from '@/lib/vuetify/theme'

export default class ServiceMesh {
  public booking_mode!: string
  public vehicle_type!: string
  public vehicle_type_id!: string

  public static colors: { [key: string]: string } = {
    RTBIKE: theme.RTBIKE,
    FFBIKE: theme.FFBIKE,
    OWFFBIKE: theme.OWFFBIKE,
    FFCAR: theme.FFCAR,
    OWFFCAR: theme.OWFFCAR,
    RTCAR: theme.RTCAR,
    CRTCAR: theme.CRTCAR,
    OWRTCAR: theme.OWRTCAR,
    FFKICKSCOOTER: theme.FFKICKSCOOTER,
    RTKICKSCOOTER: theme.RTKICKSCOOTER,
    FFSCOOTER: theme.FFSCOOTER,
    RTSCOOTER: theme.RTSCOOTER,
    RTVAN: theme.RTVAN,
    RTPLATFORM: theme.RTPLATFORM,
  }

  public get bookingModes() {
    const arr = []
    for (const bm of Object.values(BookingMode)) {
      arr.push(bm)
    }
    return arr
  }

  public get vehicleTypes() {
    const arr = []
    for (const vt of Object.values(VehicleType)) {
      arr.push(vt)
    }
    return arr
  }

  public get vehicleType() {
    const obj: {[key: string]: string} = {}
    for (const vt of Object.values(VehicleType)) {
      for (const bm of Object.values(BookingMode)) {
        obj[bm + vt] = `vehicle.${vt.toLowerCase()}.${bm.toLowerCase()}`
      }
    }
    return obj
  }

  public static getImageForFuelLevel(vehicle: Vehicle) {

    switch (true) {
      case vehicle.fuel_level >= 50:
        return 'img/icons/battery_status-50.png'
      case vehicle.fuel_level <= 50:
        return 'img/icons/battery_status-10.png'
      default:
        return 'img/icons/battery_status-100.png'
    }
  }

  public static getPolyLineColor(zone: string) {
    switch (zone) {
      case 'allowed':
        return 'green'
      case 'forbidden':
        return 'red'
      case 'undesiderable':
        return 'yellow'
      default:
        return 'grey'
    }
  }

  public static getConfirmationImage(vehicleType: string) {
    switch (vehicleType.toLowerCase()) {
      case 'car':
        return 'img/booking/car.svg'
      case 'bike':
        return 'img/booking/bike.svg'
      case 'scooter':
        return 'img/booking/scooter.svg'
      case 'kickscooter':
        return 'img/booking/kickscooter.svg'
    }
  }

  public static getVehicleType(vehicle: Vehicle) {
    return vehicle.category.type
  }

  public static getVehicleBookingMode(vehicleSlot: VehicleSlot) {
    return vehicleSlot.reservation_type
  }

  public getImage(bookingMode: BookingMode, vehicleType: VehicleType, level: string): string {
    if (this.bookingModes.indexOf(bookingMode) == -1) {
      console.error(bookingMode + ' is not present in the ServiceMesh')
    }
    if (this.vehicleTypes.indexOf(vehicleType.toUpperCase() as VehicleType) == -1) {
      console.error(vehicleType + ' is not present in the ServiceMesh')
    }
    return 'img/map/markers/' + vehicleType.toUpperCase() + '-' + bookingMode.toUpperCase() + '-' + level.toUpperCase() + '.png'
  }

  public getImageForVehicle(v: VehicleSlot, level: string = 'OK') {
    return this.getImage(v.reservation_type, v.vehicle.category.type, level)
  }

  public getImageForParking(v: VehicleSlot, level: string = 'PARK') {
    return this.getImage(v.reservation_type, v.vehicle.category.type, level)
  }

  public getClusterImage(key: string) {
    // return 'img/map/clusters/' + ServiceMesh.getColorForKey(key) + '/'
    key = key.replace('-', '')
    return 'img/map/clusters/' + ServiceMesh.colors[key].replace('#', '').toUpperCase() + '/'
  }
}
